import React from 'react';
import { MapPin, Home, CreditCard, Shield, ClipboardCheck, PenTool, FileText, HardHat, Key } from 'lucide-react';
import { mockData } from '../data/mock';

const iconMap = {
  MapPin,
  Home,
  CreditCard,
  Shield,
  ClipboardCheck,
  PenTool,
  FileText,
  HardHat,
  Key
};

// Images de fond pour certains services (par ID)
const serviceBackgrounds = {
  2: '/assets/photos/services/DSC04054.webp', // Création des plans & modélisation 3D
  4: '/assets/photos/services/DSC07940.webp', // Suivi de chantier professionnel
  6: '/assets/photos/services/couple-achete-une-nouvelle-maison.webp', // Remise des clés
};

const Services = () => {
  return (
    <section id="services" className="section-services">
      <div className="container">
        <div 
          className="section-header"
          data-aos="fade-up"
        >
          <h2 className="section-title">Nos services</h2>
          <p className="section-subtitle">
            Un accompagnement complet pour votre projet de construction
          </p>
        </div>

        <div className="services-grid">
          {mockData.services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            const bgImage = serviceBackgrounds[service.id];
            
            return (
              <div 
                key={service.id} 
                className={`service-card ${bgImage ? 'service-card-with-bg' : ''}`}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                style={bgImage ? {
                  backgroundImage: `url(${bgImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                } : {}}
              >
                {bgImage && <div className="service-card-overlay"></div>}
                <div className={`service-card-content ${bgImage ? 'relative z-10' : ''}`}>
                  <div className="service-icon">
                    {IconComponent && <IconComponent size={32} />}
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
